import styled from "styled-components";

const ContentSubTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-weight: 700;
    font-size: 1rem;
  }

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: regular;
    font-size: 0.75rem;
    cursor: pointer;
    color: #878e95;

    img {
      width: 20px;
      height: 20px;
    }
  }
`;

export { ContentSubTitleWrapper };
